module.exports = __webpack_public_path__ + "static/media/favourite-brand.a3f72e13.png";